import React from 'react';
import SocialMediaContent from '../components/social-media/SocialMediaContent';

const SocialMediaContentPage = () => {
  return <SocialMediaContent />;
};

export default SocialMediaContentPage;